// Value for an <input type="date">: "YYYY-MM-DD" in the device's LOCAL time.
// `value` is anything `new Date()` accepts; empty means "today".
export const toDateInputValue = (value) => {
  const d = value ? new Date(value) : new Date();
  if (isNaN(d.getTime())) return "";
  const pad = (n, len = 2) => String(n).padStart(len, "0");
  return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
